import Mark from "./Mark.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import IMark from "../interfaces/IMark.ts";
import RhColors from "../models/RhColors.ts";
import MathUtil from "../utils/MathUtil.ts";
import SplitText from "../components/SplitText.ts";

export default class SlideArrowMark extends Mark implements IMark
{
    private markPosition:number;
    
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetText?:SplitText, color=RhColors.MARK_PRIMARY, position:number=0)
    {
        super(color);
        this.targetSplitText = targetText;
        this.markPosition = position;
        this._init();
    }

    private _init():void
    {
        this.markWidth = 10;
        this.markHeight = 10;
        this.strokeThickness = Math.round(this.fontSize * this.strokeMultipleOfText);
        if(this.targetSplitText)
        {
            this.markWidth = 0;
            const len = this.markPosition;
            for(let i = 0; i < len; i++)
            {
                if(i == 0)
                {
                    this.parentTarget = this.targetSplitText.textFields[i];
                }
                this.markWidth += this.targetSplitText.textFields[i].width;
            }
            this.markY = this.targetSplitText.textFields[0].height;
            this.strokeThickness = Math.round(this.targetSplitText.fontSize * this.strokeMultipleOfText);
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const radius = this.strokeThickness*2.33;
        let mark = new Container();
        //DRAW HEAD
        let head = new Graphics();
        head.regularPoly(0, 0, radius, 3, MathUtil.degreesToRadians(90));
        head.fill({color:color});
        head.x = this.markWidth;
        mark.addChild(head);
        

        //DRAW LINE
        const arrowLength = this.markWidth;
        let line = new Graphics();
        line.lineTo(arrowLength, 0);
        line.stroke({color:color, width:this.strokeThickness});
        mark.addChild(line);

        //DRAW MASK
        /*const mask = new Graphics();
        mask.beginFill("#000000");
        mask.drawRect(gLeft, 0, arrowLength + this.markWidth + this.markWidth / 2, this.markWidth);
        mask.endFill();
        this.mark.mask = mask;*/

        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMark();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}